"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.project = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const wizardReducer = require("./wizard");
const homeReducer = require("./home");
const membersReducer = require("./members");
const usersReducer = require("./users");
const permissionsReducer = require("./permissions");
const copyReducer = require("./copy");
const changeReducer = require("./change");
const deleteReducer = require("./delete");
const customerUserGroupsReducer = require("./customerUserGroups");
const _dashboardReducer = require("../../modules/dashboard/reducers");
const _statusOrTypeReducer = require("../../modules/project/statusesOrTypes/reducers");
const subreducers_1 = require("../../utils/subreducers");
const dashboardReducer = _dashboardReducer.default('project');
const statusReducer = _statusOrTypeReducer.default('project-statuses');
const typeReducer = _statusOrTypeReducer.default('project-types');
const initialState = {
    wizard: Object.assign({}, wizardReducer.initialState),
    currentProject: Object.assign({}, homeReducer.initialState),
    members: Object.assign({}, membersReducer.initialState),
    users: Object.assign({}, usersReducer.initialState),
    permissions: permissionsReducer.initialState(),
    copy: Object.assign({}, copyReducer.initialState),
    delete: Object.assign({}, deleteReducer.initialState),
    dashboard: Object.assign({}, dashboardReducer.initialState),
    projectStatuses: Object.assign({}, statusReducer.initialState),
    projectTypes: Object.assign({}, typeReducer.initialState),
    customerUserGroups: Object.assign({}, customerUserGroupsReducer.initialState),
    change: Object.assign({}, changeReducer.initialState)
};
const wizardLens = monocle.Lens.fromProp('wizard');
const homeLens = monocle.Lens.fromProp('currentProject');
const usersLens = monocle.Lens.fromProp('users');
const membersLens = monocle.Lens.fromProp('members');
const permissionsLens = monocle.Lens.fromProp('permissions');
const copyLens = monocle.Lens.fromProp('copy');
const changeLens = monocle.Lens.fromProp('change');
const deleteLens = monocle.Lens.fromProp('delete');
const dashboardLens = monocle.Lens.fromProp('dashboard');
const projectStatusesLens = monocle.Lens.fromProp('projectStatuses');
const projectTypesLens = monocle.Lens.fromProp('projectTypes');
const customerUserGroupsLens = monocle.Lens.fromProp('customerUserGroups');
// Wizard
const handleWizard = (action) => (state) => wizardLens.modify((s) => wizardReducer.wizard(s, action))(state);
// Regions
const handleHome = (action) => (state) => homeLens.modify((s) => homeReducer.home(s, action))(state);
const handleMembers = (action) => (state) => membersLens.modify((s) => membersReducer.members(s, action))(state);
const handleUsers = (action) => (state) => {
    const fn = usersReducer.methods[action.type];
    if (fn) {
        return usersLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handlePermissions = (action) => (state) => {
    const fn = permissionsReducer.methods[action.type];
    if (fn) {
        return permissionsLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleCopy = (action) => (state) => {
    const fn = copyReducer.methods[action.type];
    if (fn) {
        return copyLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleDelete = (action) => (state) => {
    const fn = deleteReducer.methods[action.type];
    if (fn) {
        return deleteLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleDashboard = (action) => (state) => {
    const fn = dashboardReducer.methods[action.type];
    if (fn) {
        return dashboardLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleProjectStatuses = (action) => (state) => {
    const fn = statusReducer.methods[action.type];
    if (fn) {
        return projectStatusesLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleProjectTypes = (action) => (state) => {
    const fn = typeReducer.methods[action.type];
    if (fn) {
        return projectTypesLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleCustomerUserGroups = (action) => (state) => {
    const fn = customerUserGroupsReducer.methods[action.type];
    if (fn) {
        return customerUserGroupsLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const project = (state = initialState, action) => {
    return fp.function.compose(handleMembers(action), handleWizard(action), handleHome(action), handleUsers(action), handlePermissions(action), fp.function.compose(handleCustomerUserGroups(action), handleCopy(action), handleDelete(action), handleDashboard(action), handleProjectStatuses(action), handleProjectTypes(action)), (0, subreducers_1.handleSubreducer)(action, changeReducer, changeLens))(state);
};
exports.project = project;
//# sourceMappingURL=index.js.map